module.exports = __webpack_public_path__ + "img/arrow.856f8a18.png";